import { Contract } from '../../types/firestore/Game/Collection/Item';
import { v4 as uuidv4 } from 'uuid';
export const getItemKey = (
  contract: Pick<Contract, 'chainId' | 'address' | 'itemId'>,
) => {
  if (!contract) {
    return `NO-CONTRACT-${uuidv4()}`;
  }
  return `${contract.chainId}-${contract.address}-${contract.itemId}`;
};
